/**
 * Subtle inline "Loading …" indicator for rail sections that fetch their data
 * incrementally (canvases, chats, files, a folder's contents). Shown while the
 * first fetch is in flight so a section fills in smoothly instead of flashing
 * from an empty state to populated. Mirrors the canvas-files loading line.
 */
export function RailSectionLoading({ label }: { label: string }) {
  return (
    <p className="px-2 py-1 text-sm text-n-40" aria-live="polite">
      Loading {label}…
    </p>
  );
}
